import {makeStyles, Theme} from '@material-ui/core';
import {Nullable} from 'common/types';
import {ProIcon} from 'components/ProLabel';
import {ResizedImage} from 'components/ResizedImage';
import React, {FunctionComponent} from 'react';

export interface UserAvatarProps {
  imageKey?: Nullable<string>;
  rounded?: boolean;
  round?: boolean;
  width: number;
  height: number;
  className?: string;
  isVerified?: boolean;
  isPro?: boolean;
}

const useStyles = makeStyles<Theme, UserAvatarProps>(theme => ({
  placeholder: {
    width: props => props.width,
    height: props => props.width,
    borderRadius: props => (props.round ? '50%' : theme.shape.borderRadius),
  },
  avatarWrapper: {
    position: 'relative',
    width: props => props.width,
    height: props => props.width,
  },
  verified: {
    position: 'absolute',
    top: '-4px',
    right: '-4px',
  },
  proLabel: {
    position: 'absolute',
    bottom: '-4px',
    right: '-4px',
  },
}));

const bankidImg = require('screens/common/assets/verified-icon.svg');

const UserAvatar: FunctionComponent<UserAvatarProps> = (
  props: UserAvatarProps
) => {
  const {
    imageKey,
    width,
    height,
    rounded,
    round,
    className,
    isVerified,
    isPro,
  } = props;
  const classes = useStyles(props);
  if (!imageKey) {
    return (
      <img
        className={`${classes.placeholder} ${props.className}`}
        src={require('screens/common/assets/placeholder.svg')}
        alt=""
      />
    );
  }

  return (
    <div className={classes.avatarWrapper}>
      <ResizedImage
        imageKey={imageKey}
        width={width}
        height={height}
        rounded={rounded}
        round={round}
        className={className}
      />

      {
        isVerified
          ? <img src={bankidImg} className={classes.verified} alt=""/>
          : null
      }

      {
        isPro ? <ProIcon variant={'small'} className={classes.proLabel}/> : null
      }
    </div>
  );
};

export default UserAvatar;
